import React,{useEffect,useState} from 'react';
import {CDNImage} from '../../components/Elements/Image';
import {useAppSelector} from '../../hooks';
import {avatarPosePath} from '../../util/poseAsset';

export function ArenaPortrait(){
 const model=useAppSelector(s=>s.inventory.items[s.inventory.locations[300]]?.props?.avatar??s.stats.stats.avatar);
 const [fallback,setFallback]=useState(false);
 useEffect(()=>setFallback(false),[model]);
 if(!Number.isSafeInteger(Number(model))||Number(model)<=0)return null;
 return <CDNImage key={`${model}-${fallback}`} src={fallback?avatarPosePath(model,`avatars/${model}`):`portraits/${model}.png`} alt="ภาพตัวละครในสนามประลอง" className="arena-player-portrait" onError={()=>{if(!fallback)setFallback(true);}}/>;
}
